<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="job名称" prop="jobName">
              <el-input v-model="searchForm.jobName" placeholder="请输入job名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button :size="buttonSize" type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button :size="buttonSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
          >新增</el-button>
          <el-button
            :size="buttonSize"
            type="danger"
            @click="batchDeleteSchedule"
            icon="el-icon-minus"
          >批量删除</el-button>
          <el-button :size="buttonSize" type="primary" @click="trigger">立即执行</el-button>
          <el-button :size="buttonSize" type="primary" @click="resume">恢复</el-button>
          <el-button :size="buttonSize" type="primary" @click="pause">暂停</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
          >导入</el-button>
          <el-button
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="jobName" label="job名称"></el-table-column>
        <el-table-column prop="jobGroup" label="job组"></el-table-column>
        <el-table-column prop="triggerName" label="trigger名称"></el-table-column>
        <el-table-column prop="triggerGroup" label="trigger组"></el-table-column>
        <el-table-column prop="cronExpression" label="表达式"></el-table-column>
        <el-table-column prop="triggerState" label="状态"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
              <span @click="deleteSchedule(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-form-item label="job名称" prop="jobName">
          <el-input
            v-model="addForm.jobName"
            placeholder="请输入job名称"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="job组" prop="jobGroup">
          <el-input
            v-model="addForm.jobGroup"
            placeholder="请输入job组"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="job类" prop="jobClassName">
          <el-input
            v-model="addForm.jobClassName"
            placeholder="请输入job类"
            auto-complete="off"
            maxlength="250"
          ></el-input>
        </el-form-item>
        <el-form-item label="cron表达式" prop="cronExpression">
          <el-input
            v-model="addForm.cronExpression"
            placeholder="请输入cron表达式"
            auto-complete="off"
            maxlength="120"
          ></el-input>
        </el-form-item>
        <el-form-item label="trigger名称" prop="triggerName">
          <el-input
            v-model="addForm.triggerName"
            placeholder="请输入trigger名称"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="trigger组" prop="triggerGroup">
          <el-input
            v-model="addForm.triggerGroup"
            placeholder="请输入trigger组"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="triggerGroup">
          <el-input
            type="textarea"
            v-model="addForm.description"
            placeholder="请输入描述"
            auto-complete="off"
            maxlength="250"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="addSchedule">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="job名称" prop="jobName">
          <el-input
            v-model="addForm.jobName"
            placeholder="请输入job名称"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="job组" prop="jobGroup">
          <el-input
            v-model="addForm.jobGroup"
            placeholder="请输入job组"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="job类" prop="jobClassName">
          <el-input
            v-model="addForm.jobClassName"
            placeholder="请输入job类"
            auto-complete="off"
            maxlength="250"
          ></el-input>
        </el-form-item>
        <el-form-item label="cron表达式" prop="cronExpression">
          <el-input
            v-model="addForm.cronExpression"
            placeholder="请输入cron表达式"
            auto-complete="off"
            maxlength="120"
          ></el-input>
        </el-form-item>
        <el-form-item label="trigger名称" prop="triggerName">
          <el-input
            v-model="addForm.triggerName"
            placeholder="请输入trigger名称"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="trigger组" prop="triggerGroup">
          <el-input
            v-model="addForm.triggerGroup"
            placeholder="请输入trigger组"
            auto-complete="off"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="triggerGroup">
          <el-input
            type="textarea"
            v-model="addForm.description"
            placeholder="请输入描述"
            auto-complete="off"
            maxlength="250"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateSchedule">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="buttonSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="jobName" label="job名称"></el-table-column>
        <el-table-column prop="jobGroup" label="job组"></el-table-column>
        <el-table-column prop="triggerName" label="trigger名称"></el-table-column>
        <el-table-column prop="triggerGroup" label="trigger组"></el-table-column>
        <el-table-column prop="cronExpression" label="表达式"></el-table-column>
        <el-table-column prop="triggerState" label="状态"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        jobName: ""
      },
      styles: {
        width: "300px"
      },
      selectParams: {
        clearable: true,
        placeholder: "请选择资源"
      },
      addForm: {},
      addFormRules: {
        jobName: [
          {
            required: true,
            message: "请输入job名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "job名称长度在1到200个字"
          }
        ],
        jobGroup: [
          {
            required: true,
            message: "请输入job组",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "job组长度在1到200个字"
          }
        ],
        jobClassName: [
          {
            required: true,
            message: "请输入job类",
            trigger: "blur"
          },
          {
            min: 1,
            max: 250,
            message: "job类长度在1到250个字"
          }
        ],
        cronExpression: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur"
          },
          {
            min: 1,
            max: 120,
            message: "备注长度在1到120个字"
          }
        ],
        triggerName: [
          {
            required: true,
            message: "请输入trigger名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "trigger名称长度在1到200个字"
          }
        ],
        triggerGroup: [
          {
            required: true,
            message: "请输入trigger组",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "trigger组长度在1到200个字"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur"
          },
          {
            min: 1,
            max: 250,
            message: "角色名称长度在1到250个字"
          }
        ]
      },
      editForm: {},
      editFormRules: {
        jobName: [
          {
            required: true,
            message: "请输入job名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "job名称长度在1到200个字"
          }
        ],
        jobGroup: [
          {
            required: true,
            message: "请输入job组",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "job组长度在1到200个字"
          }
        ],
        jobClassName: [
          {
            required: true,
            message: "请输入job类",
            trigger: "blur"
          },
          {
            min: 1,
            max: 250,
            message: "job类长度在1到250个字"
          }
        ],
        cronExpression: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur"
          },
          {
            min: 1,
            max: 120,
            message: "备注长度在1到120个字"
          }
        ],
        triggerName: [
          {
            required: true,
            message: "请输入trigger名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "trigger名称长度在1到200个字"
          }
        ],
        triggerGroup: [
          {
            required: true,
            message: "请输入trigger组",
            trigger: "blur"
          },
          {
            min: 1,
            max: 200,
            message: "trigger组长度在1到200个字"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入描述",
            trigger: "blur"
          },
          {
            min: 1,
            max: 250,
            message: "角色名称长度在1到250个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "120px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/schedule/upload`,
      fileList: [],
      loading: false,

      buttonSize: document.body.clientWidth < 992 ? "mini" : ""
    };
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e =>
        this.ids.push({
          jobName: e.jobName,
          jobGroup: e.jobGroup
        })
      );
    },
    getSchedule() {
      this.api.schedule
        .getScheduleById(this.selection)
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.schedule
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addSchedule() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.schedule
            .addSchedule(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateSchedule() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.schedule
            .updateSchedule(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteSchedule(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.schedule
            .deleteSchedule([
              {
                jobName: row.jobName,
                jobGroup: row.jobGroup
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteSchedule() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.schedule
            .deleteSchedule(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.api.schedule
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.loading = true;
      this.api.schedule
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.importFormVisible = false;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    trigger() {
      this.api.schedule
        .trigger(this.ids)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    resume() {
      this.api.schedule
        .resume(this.ids)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    pause() {
      this.api.schedule
        .pause(this.ids)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getSchedule();
      }
    }
  },
  mounted() {
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/schedule/index.vue